export const CompanyActionTypes = {
  RETRIEVE_COMPANIES: "RETRIEVE_COMPANIES",
  RETRIEVE_COMPANY_DETAILS: "RETRIEVE_COMPANY_DETAILS",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  RESET_COMPANY: "RESET_COMPANY",
};

export default CompanyActionTypes;
